import axios from 'axios';
import { authHeaders } from './authServices';

export const fetchZakazky = (size = 'all') => {
  return axios({
    method: 'get',
    ...authHeaders(),
    url: `${process.env.REACT_APP_DEV_URL}/api/v1/contracts?size=${size}`,
  });
};

export const addZakazkaService = (item) => {
  return axios({
    method: 'post',
    ...authHeaders(),
    url: `${process.env.REACT_APP_DEV_URL}/api/v1/contracts`,
    data: item,
  });
};

export const deleteZakazkaService = (id) => {
  return axios({
    method: 'delete',
    ...authHeaders(),
    url: `${process.env.REACT_APP_DEV_URL}/api/v1/contracts/${id}`,
  });
};

export const editZakazkaService = (id, item) => {
  return axios({
    method: 'put',
    ...authHeaders(),
    url: `${process.env.REACT_APP_DEV_URL}/api/v1/contracts/${id}`,
    data: item,
  });
};

export const switchZakazkaService = (on, type, id) => {
  return axios({
    method: 'put',
    ...authHeaders(),
    url: `${process.env.REACT_APP_DEV_URL}/api/v1/contracts/switch/${id}`,
    data: {
      type,
      on,
    },
  });
};

export const uploadFilesService = (id, files) => {
  return axios.post(`${process.env.REACT_APP_DEV_URL}/api/v1/files/upload/${id}`, files, {
    headers: {
      ...authHeaders().headers,
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const removeFileService = (id) => {
  return axios({
    method: 'delete',
    ...authHeaders(),
    url: `${process.env.REACT_APP_DEV_URL}/api/v1/files/remove/${id}`,
  });
};
